module.exports = __webpack_public_path__ + "img/ERGO_Icon_black_at_Zeichen.9cad0671.svg";